// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"AV-z","inlineTitle":"BV-z","sponsoredAdsWrapper":"CV-z","marketplaceRecosWrapper":"DV-z"};